(() => {
  // Drawer / modal toggles: any [data-toggle="#id"] toggles [open] on the target <details> or [hidden] on others
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-toggle]');
    if (!toggle) return;
    const target = document.querySelector(toggle.dataset.toggle);
    if (!target) return;
    e.preventDefault();
    if (target.tagName === 'DIALOG') {
      target.open ? target.close() : target.showModal();
    } else {
      target.hidden = !target.hidden;
    }
  });

  // Quantity steppers
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = btn.closest('[data-qty]').querySelector('input[type="number"]');
    const step = Number(btn.dataset.qtyChange);
    const next = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Predictive search
  document.querySelectorAll('[data-predictive-search]').forEach((search) => {
    const input = search.querySelector('input[type="search"]');
    const results = search.querySelector('[data-predictive-results]');
    let controller;
    const show = (visible) => {
      results.hidden = !visible;
      input.setAttribute('aria-expanded', String(visible));
    };
    input.addEventListener('input', async () => {
      const q = input.value.trim();
      if (controller) controller.abort();
      if (q.length < 2) { show(false); results.innerHTML = ''; return; }
      controller = new AbortController();
      try {
        const res = await fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}search/suggest?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,query&resources[limit]=6`, { signal: controller.signal });
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const inner = doc.querySelector('[data-predictive-inner]');
        results.innerHTML = inner ? inner.innerHTML : '';
        show(!!results.innerHTML.trim());
      } catch (err) {
        if (err.name !== 'AbortError') show(false);
      }
    });
    // Escape closes the suggestions and keeps focus in the field; focusing the field again reopens them.
    search.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !results.hidden) { e.preventDefault(); show(false); input.focus(); }
    });
    input.addEventListener('focus', () => { if (results.innerHTML.trim()) show(true); });
    document.addEventListener('click', (e) => {
      if (!search.contains(e.target)) show(false);
    });
  });

  // Desktop mega menus and dropdowns open on hover/focus; Escape closes the open one by moving focus to its trigger.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const item = document.activeElement && document.activeElement.closest('.header__nav-item--mega, .header__nav-item--drop');
    if (!item) return;
    const trigger = item.querySelector('.header__nav-link');
    if (trigger) { trigger.focus(); trigger.blur(); }
  });

  // Background video (hero, feature split, video section): pause/play toggle, and never autoplay for reduced motion.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-autoplay-video]').forEach((wrap) => {
    const video = wrap.querySelector('video');
    const toggle = wrap.querySelector('[data-video-toggle]');
    if (!video || !toggle) return;
    const setPaused = (paused) => {
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
    };
    const pause = () => { video.pause(); setPaused(true); };
    const play = () => { video.play().then(() => setPaused(false)).catch(() => setPaused(true)); };
    if (reduceMotion.matches) { video.removeAttribute('autoplay'); pause(); }
    toggle.addEventListener('click', () => (video.paused ? play() : pause()));
    video.addEventListener('pause', () => setPaused(true));
    video.addEventListener('play', () => setPaused(false));
  });

  // Related products: the Product Recommendations API only populates `recommendations` on a section
  // fetched through it, so swap in that render when it brings back any products.
  document.querySelectorAll('[data-recommendations]').forEach(async (section) => {
    try {
      const res = await fetch(section.dataset.recommendationsUrl);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = doc.querySelector('[data-recommendations-grid]');
      if (!grid || !grid.children.length) return;
      const current = section.querySelector('.grid');
      if (current) current.replaceWith(grid);
    } catch (_) {}
  });

  // Collection filters: collapsed by default on small screens
  if (window.matchMedia('(max-width: 989px)').matches) {
    document.querySelectorAll('[data-filters-wrap]').forEach((d) => d.removeAttribute('open'));
  }

  // Collection sort: submit filter form on change
  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  // Product media gallery
  const gallery = document.querySelector('[data-gallery]');
  function activateMedia(id) {
    if (!gallery) return;
    const thumb = gallery.querySelector(`[data-media-id="${id}"]`);
    if (!thumb) return;
    gallery.querySelectorAll('[data-media-id]').forEach((t) => t.classList.toggle('is-active', t === thumb));
    document.querySelectorAll('[data-main-media]').forEach((m) => {
      m.hidden = m.dataset.mainMedia !== String(id);
      const v = m.querySelector('video');
      if (v && m.hidden) v.pause();
      const f = m.querySelector('iframe');
      if (f && m.hidden) f.src = f.src;
    });
  }
  window.activateProductMedia = activateMedia;
  if (gallery) {
    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-media-id]');
      if (thumb) activateMedia(thumb.dataset.mediaId);
    });
  }

  // Sticky add-to-cart: show when the main button leaves the viewport (mobile only)
  const sticky = document.querySelector('[data-sticky-atc]');
  const mainAdd = document.querySelector('[data-product-form] [data-add-button]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    const mq = window.matchMedia('(max-width: 749px)');
    const update = () => {
      const r = mainAdd.getBoundingClientRect();
      const show = mq.matches && r.bottom <= 0;
      sticky.hidden = !show;
      document.body.classList.toggle('has-sticky-atc', show);
    };
    // The observer covers normal scrolling; the scroll listener covers jump scrolls
    // (e.g. scrollTo) that skip over the button without ever intersecting it.
    new IntersectionObserver(update, { threshold: 0 }).observe(mainAdd);
    window.addEventListener('scroll', update, { passive: true });
    mq.addEventListener('change', update);
  }
})();

(() => {
  // Announcement bar: dismiss for the session
  const bar = document.querySelector('[data-announcement-dismissible]');
  if (bar) {
    const key = 'announcement-dismissed-' + bar.dataset.announcement;
    const inEditor = window.Shopify && window.Shopify.designMode;
    if (!inEditor && sessionStorage.getItem(key)) bar.hidden = true;
    bar.addEventListener('click', (e) => {
      if (!e.target.closest('[data-announcement-dismiss]')) return;
      bar.hidden = true;
      try { sessionStorage.setItem(key, '1'); } catch (_) {}
    });
  }

  // Click-to-play video covers (video section, feature split)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-video-play]');
    if (!btn) return;
    const frame = btn.closest('[data-video]');
    const tpl = frame && frame.querySelector('[data-video-template]');
    if (!tpl) return;
    frame.appendChild(tpl.content.cloneNode(true));
    frame.classList.add('is-playing');
    const video = frame.querySelector('video');
    if (video) video.play().catch(() => {});
  });
})();

(() => {
  // Promo popup: shows on a first visit, again after N days, or as soon as its content changes.
  // localStorage holds { v: content version, t: last shown, done: signed up / copied / clicked }.
  const KEY = 'promo-popup';
  const SUBMITTED = KEY + '-submitted';
  const inEditor = window.Shopify && window.Shopify.designMode;

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (_) { return null; }
  };
  const write = (rec) => {
    if (inEditor) return;
    try { localStorage.setItem(KEY, JSON.stringify(rec)); } catch (_) {}
  };

  const open = (popup) => {
    if (popup.open || !popup.isConnected) return;
    // Don't stack on top of the cart drawer; wait for it to close.
    const other = document.querySelector('dialog[open]');
    if (other) { other.addEventListener('close', () => open(popup), { once: true }); return; }
    popup.showModal();
    document.body.classList.add('promo-popup-open');
  };

  // A visit that starts from warranty registration gets the owners' welcome instead (warranty welcome below).
  const warrantyVisit = () => {
    try { return new URLSearchParams(location.search).has('warranty') || sessionStorage.getItem('warranty-welcome') === '1'; } catch (_) { return false; }
  };

  const init = (popup) => {
    if (!inEditor && warrantyVisit()) return;
    const version = popup.dataset.version;
    const markDone = () => write({ v: version, t: Date.now(), done: true });

    popup.addEventListener('click', (e) => {
      if (e.target === popup || e.target.closest('[data-promo-close]')) { popup.close(); return; }
      if (e.target.closest('[data-promo-convert]')) markDone();
      const copy = e.target.closest('[data-promo-copy]');
      if (copy) {
        const code = popup.querySelector('[data-promo-code]');
        const done = () => { copy.textContent = copy.dataset.copiedLabel; markDone(); };
        // Clipboard needs a secure context; fall back to selecting the code for a manual copy.
        if (navigator.clipboard) navigator.clipboard.writeText(code.textContent.trim()).then(done, () => window.getSelection().selectAllChildren(code));
        else window.getSelection().selectAllChildren(code);
      }
    });
    popup.addEventListener('close', () => document.body.classList.remove('promo-popup-open'));

    // The signup posts natively (Shopify may route it through a captcha page), so the result
    // arrives on the next page load. Only reopen for it if this popup's form was the one sent;
    // otherwise a footer signup would surface here as a stray "thanks".
    const form = popup.querySelector('form');
    if (form) form.addEventListener('submit', () => { try { sessionStorage.setItem(SUBMITTED, Date.now()); } catch (_) {} });
    const result = popup.querySelector('[data-promo-result]');
    if (result) {
      // Read the flag only where a result is shown, so an in-between captcha page can't consume it.
      // A stale flag (abandoned submit) mustn't claim a later footer signup.
      let submitted = false;
      try {
        submitted = Date.now() - Number(sessionStorage.getItem(SUBMITTED)) < 6e5;
        sessionStorage.removeItem(SUBMITTED);
      } catch (_) {}
      if (submitted && !inEditor) {
        if (result.dataset.promoResult === 'success') markDone();
        open(popup);
        return;
      }
      result.remove();
      popup.querySelector('[data-promo-fields]').hidden = false;
    }

    if (inEditor) return;

    const rec = read();
    if (!rec) return; // no storage: better never than on every page
    const days = Number(popup.dataset.days) || 14;
    const changed = rec.v !== version;
    const due = Date.now() - (rec.t || 0) > days * 864e5;
    if (!changed && (rec.done || !due)) return;

    // Lazy images in a closed dialog only load once it opens; start the download now instead.
    popup.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });

    const disarm = [];
    let fired = false;
    const fire = () => {
      if (fired) return;
      fired = true;
      disarm.forEach((fn) => fn());
      open(popup);
      // Count it as seen on open, so navigating away without closing doesn't re-show it on every page.
      write({ v: version, t: Date.now(), done: false });
    };

    const delay = Number(popup.dataset.delay);
    const scroll = Number(popup.dataset.scroll);
    const exit = popup.hasAttribute('data-exit-intent') && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (delay) {
      const id = setTimeout(fire, delay * 1000);
      disarm.push(() => clearTimeout(id));
    }
    if (scroll) {
      const scrollable = () => document.documentElement.scrollHeight - window.innerHeight;
      const onScroll = () => {
        const max = scrollable();
        if (max > 0 && (window.scrollY / max) * 100 >= scroll) fire();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      disarm.push(() => window.removeEventListener('scroll', onScroll));
      // A page too short to scroll can never reach the threshold; fall back to a short delay.
      if (!delay) {
        const check = () => { if (scrollable() <= 0) { const id = setTimeout(fire, 5000); disarm.push(() => clearTimeout(id)); } };
        if (document.readyState === 'complete') check();
        else window.addEventListener('load', check, { once: true });
      }
    }
    if (exit) {
      const onLeave = (e) => { if (e.clientY <= 0) fire(); };
      document.documentElement.addEventListener('mouseleave', onLeave);
      disarm.push(() => document.documentElement.removeEventListener('mouseleave', onLeave));
    }
    if (!disarm.length) fire();
  };

  const popup = document.querySelector('[data-promo-popup]');
  if (popup) init(popup);

  // Theme editor: show it while its section is selected, and never touch the shopper's record.
  if (inEditor) {
    const find = (e) => e.target.querySelector('[data-promo-popup]');
    document.addEventListener('shopify:section:load', (e) => {
      const p = find(e);
      if (!p) return;
      document.body.classList.remove('promo-popup-open');
      init(p);
      open(p);
    });
    document.addEventListener('shopify:section:select', (e) => { const p = find(e); if (p) open(p); });
    document.addEventListener('shopify:section:deselect', (e) => { const p = find(e); if (p && p.open) p.close(); });
  }
})();

(() => {
  // Warranty registration form (sections/warranty-registration.liquid). Posts to the app proxy and
  // follows the redirect it returns; field errors come back as keys mapped to the section's strings.
  const form = document.querySelector('[data-warranty-form]');
  if (!form) return;

  let messages = {};
  try { messages = JSON.parse(document.querySelector('[data-warranty-errors]').textContent); } catch (_) {}
  const formError = form.querySelector('[data-form-error]');
  const button = form.querySelector('[type="submit"]');
  const idleLabel = button.textContent;
  // Shrinking a photo, uploading and registering can take a few seconds on a phone.
  const setBusy = (busy) => {
    button.textContent = busy ? button.dataset.busyLabel || idleLabel : idleLabel;
    if (busy) { button.setAttribute('aria-busy', 'true'); form.setAttribute('aria-busy', 'true'); }
    else { button.removeAttribute('aria-busy'); form.removeAttribute('aria-busy'); }
  };

  // The invoice input is visually hidden behind a styled button; show what was picked.
  const invoiceInput = form.querySelector('[name="invoice"]');
  const invoiceName = form.querySelector('[data-invoice-name]');
  const invoiceRemove = form.querySelector('[data-invoice-remove]');
  const showInvoice = () => {
    const file = invoiceInput?.files?.[0];
    if (invoiceName) invoiceName.textContent = file ? file.name : '';
    if (invoiceRemove) invoiceRemove.hidden = !file;
  };
  if (invoiceInput) invoiceInput.addEventListener('change', showInvoice);
  if (invoiceRemove) invoiceRemove.addEventListener('click', () => { invoiceInput.value = ''; showInvoice(); invoiceInput.focus(); });

  // With Turnstile on the page, submitting waits for its token. The page stays open after a submit,
  // so the widget is rendered explicitly and reset by its ID; each token is single-use.
  const widget = form.querySelector('.cf-turnstile');
  let widgetId = null;
  let hasToken = !widget;
  const sync = () => { button.disabled = !hasToken; };
  const noToken = () => { hasToken = !widget; sync(); };
  // api.js calls this once loaded (?render=explicit&onload=warrantyTurnstileLoad).
  window.warrantyTurnstileLoad = () => {
    if (!widget || widgetId !== null) return;
    widgetId = window.turnstile.render(widget, {
      sitekey: widget.dataset.sitekey,
      action: widget.dataset.action,
      size: 'flexible',
      // Hidden unless Cloudflare needs the visitor to click; light to match the page when it shows.
      appearance: 'interaction-only',
      theme: 'light',
      callback: () => { hasToken = true; sync(); },
      'expired-callback': noToken,
      'error-callback': noToken,
    });
  };
  const resetTurnstile = () => {
    if (!widget) return;
    hasToken = false;
    if (window.turnstile && widgetId !== null) window.turnstile.reset(widgetId);
  };
  sync();

  const INVOICE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
  const INVOICE_MAX = 5 * 1024 * 1024;
  const INVOICE_EDGE = 2000;

  // Phone photos are often over 5 MB and carry the GPS location they were taken at. Redrawing
  // them at up to 2000px as a JPEG keeps an invoice readable at a few hundred KB and drops all
  // metadata. PDFs are sent as they are; if the browser can't redraw, the original goes up.
  const shrinkInvoice = async (file) => {
    if (!file.type.startsWith('image/') || !window.createImageBitmap) return file;
    try {
      const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
      const scale = Math.min(1, INVOICE_EDGE / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff'; // transparent PNG areas would otherwise turn black
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      bitmap.close();
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.8));
      if (!blob) return file;
      return new File([blob], file.name.replace(/\.[^.]*$/, '') + '.jpg', { type: 'image/jpeg' });
    } catch (_) {
      return file;
    }
  };
  const fieldError = (field, key) => {
    form.querySelectorAll(`[data-field-error="${field}"]`).forEach((el) => {
      if (el.parentElement.closest('[hidden]')) return; // the other channels' copies
      el.textContent = messages[key] || messages.required || '';
      el.hidden = false;
    });
    form.querySelectorAll(`[name="${field}"]:not(:disabled)`).forEach((input) => input.setAttribute('aria-invalid', 'true'));
  };

  const product = form.querySelector('[data-warranty-product]');
  const badge = form.querySelector('[data-warranty-badge]');
  const showBadge = () => {
    const warranty = product.selectedOptions[0]?.dataset.warranty;
    badge.hidden = !warranty;
    if (warranty) badge.textContent = warranty === 'lifetime' ? badge.dataset.lifetime : badge.dataset.twoYear;
  };
  if (product && badge) { product.addEventListener('change', showBadge); showBadge(); }

  // Only the chosen channel's fields are enabled, so the others aren't submitted.
  const showChannel = () => {
    const chosen = form.querySelector('[data-channel-input]:checked')?.value;
    form.querySelectorAll('[data-channel-panel]').forEach((panel) => {
      const on = panel.dataset.channelPanel === chosen;
      panel.hidden = !on;
      panel.querySelectorAll('input').forEach((input) => { input.disabled = !on; });
    });
  };
  form.addEventListener('change', (e) => { if (e.target.matches('[data-channel-input]')) showChannel(); });
  showChannel();

  const clearErrors = () => {
    form.querySelectorAll('[data-field-error]').forEach((el) => { el.hidden = true; el.textContent = ''; });
    form.querySelectorAll('[aria-invalid]').forEach((el) => el.removeAttribute('aria-invalid'));
    formError.hidden = true;
  };
  // Same rules as the Worker (workers/warranty/src/validate.js), checked here as well so a slip
  // shows as soon as the buyer leaves the field instead of after a round trip.
  const phoneOk = (value) => {
    let digits = value.replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2);
    else if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
    return /^[6-9]\d{9}$/.test(digits);
  };
  const emailOk = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  const RULES = { phone: phoneOk, email: emailOk };
  const clearField = (field) => {
    form.querySelectorAll(`[data-field-error="${field}"]`).forEach((el) => { el.hidden = true; el.textContent = ''; });
    form.querySelectorAll(`[name="${field}"]`).forEach((input) => input.removeAttribute('aria-invalid'));
  };
  // An empty field passes here; "required" is the browser's check on submit.
  const checkField = (field) => {
    const value = form.querySelector(`[name="${field}"]`).value.trim();
    if (!value || RULES[field](value)) { clearField(field); return true; }
    fieldError(field, field);
    return false;
  };
  // Pressing submit takes focus from the field first. Showing its error then would push the button
  // down before the click lands and swallow it; the submit handler runs the same check instead.
  let pressingSubmit = false;
  const released = () => setTimeout(() => { pressingSubmit = false; });
  button.addEventListener('pointerdown', () => { pressingSubmit = true; });
  document.addEventListener('pointerup', released, true);
  document.addEventListener('pointercancel', released, true);
  for (const field of Object.keys(RULES)) {
    const input = form.querySelector(`[name="${field}"]`);
    if (!input) continue;
    input.addEventListener('blur', () => { if (!pressingSubmit) checkField(field); });
    input.addEventListener('input', () => {
      // Letters can't be part of a phone number; drop them as they're typed.
      if (field === 'phone') {
        const clean = input.value.replace(/[^\d\s+-]/g, '');
        if (clean !== input.value) input.value = clean;
      }
      if (input.getAttribute('aria-invalid') === 'true') checkField(field);
    });
  }

  const showFormError = (key) => {
    formError.textContent = messages[key] || messages.server || '';
    formError.hidden = false;
    resetTurnstile();
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearErrors();
    // Catch slips here rather than spend a round trip and a Turnstile token on them.
    const valid = Object.keys(RULES).filter((f) => form.querySelector(`[name="${f}"]`)).map(checkField);
    if (valid.includes(false)) { form.querySelector('[aria-invalid="true"]').focus(); return; }
    if (!form.reportValidity()) return;
    let invoice = form.querySelector('[name="invoice"]')?.files?.[0];
    if (invoice && !INVOICE_TYPES.includes(invoice.type)) { fieldError('invoice', 'file_type'); return; }
    button.disabled = true;
    setBusy(true);
    let leaving = false;
    try {
      const body = new FormData(form);
      if (invoice) {
        invoice = await shrinkInvoice(invoice);
        if (invoice.size > INVOICE_MAX) { fieldError('invoice', 'file_size'); return; }
        body.set('invoice', invoice, invoice.name);
      }
      const res = await fetch(form.action, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await res.json().catch(() => ({}));
      // Stays busy while the browser navigates away.
      if (res.ok && data.redirect) { leaving = true; window.location.href = data.redirect; return; }

      const errors = data.errors || { form: 'server' };
      if (errors.form || res.status !== 422) { showFormError(errors.form || 'server'); return; }
      for (const [field, key] of Object.entries(errors)) fieldError(field, key);
      // Focus the first field in error, in page order.
      const first = form.querySelector('[aria-invalid="true"]');
      if (first) first.focus();
      resetTurnstile();
    } catch (_) {
      showFormError('server');
    } finally {
      if (!leaving) { setBusy(false); sync(); }
    }
  });
})();

(() => {
  // Owners' welcome after warranty registration (snippets/warranty-welcome.liquid). The token in the URL
  // is single-use: it's removed straight away so a refresh, Back or a shared link can't reuse it.
  const dialog = document.querySelector('[data-warranty-welcome]');
  const params = new URLSearchParams(location.search);
  const token = params.get('warranty');
  if (!dialog || !token) return;

  params.delete('warranty');
  const query = params.toString();
  history.replaceState(history.state, '', location.pathname + (query ? '?' + query : '') + location.hash);
  // Keeps the promo popup away for the rest of the visit.
  try { sessionStorage.setItem('warranty-welcome', '1'); } catch (_) {}

  const $ = (sel) => dialog.querySelector(sel);
  // Templates carry __name__ / __percent__: Shopify's Liquid can't parse braces inside a {{ }} string.
  const fill = (tpl, values) => tpl.replace(/__(\w+)__/g, (_, k) => values[k] ?? '');

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog || e.target.closest('[data-ww-close]')) { dialog.close(); return; }
    const copy = e.target.closest('[data-ww-copy]');
    if (!copy) return;
    const code = $('[data-ww-code]');
    const done = () => { copy.textContent = copy.dataset.copiedLabel; };
    if (navigator.clipboard) navigator.clipboard.writeText(code.textContent.trim()).then(done, () => window.getSelection().selectAllChildren(code));
    else window.getSelection().selectAllChildren(code);
  });
  dialog.addEventListener('close', () => document.body.classList.remove('promo-popup-open'));

  fetch(dialog.dataset.claimUrl + '?token=' + encodeURIComponent(token), { headers: { Accept: 'application/json' } })
    .then((res) => (res.ok ? res.json() : null))
    .then((claim) => {
      if (!claim) return;
      // The code's expiry, as the date in India.
      const date = claim.expiresAt
        ? new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Kolkata' }).format(new Date(claim.expiresAt))
        : '';
      // The minimum comes from the Worker, which sets it on the discount, so the popup can't disagree with checkout.
      const minimum = claim.minimum ? new Intl.NumberFormat('en-IN').format(claim.minimum) : '';
      const values = { name: claim.firstName || '', percent: claim.percent, date, minimum };
      const heading = $('[data-ww-heading]');
      if (claim.code) {
        heading.textContent = fill(heading.dataset.offer, values);
        $('[data-ww-percent]').textContent = fill($('[data-ww-percent]').dataset.template, values);
        const line = $('[data-ww-channel-line]');
        line.textContent = ['amazon', 'flipkart'].includes(claim.channel) ? line.dataset.marketplace : line.dataset.other;
        $('[data-ww-code]').textContent = claim.code;
        $('[data-ww-cta]').textContent = fill($('[data-ww-cta]').dataset.template, values);
        $('[data-ww-terms]').textContent = fill($('[data-ww-terms]').dataset.template, values);
        $('[data-ww-offer]').hidden = false;
      } else {
        heading.textContent = fill(claim.resent ? heading.dataset.resent : heading.dataset.plain, values);
        $(claim.resent ? '[data-ww-resent]' : '[data-ww-plain]').hidden = false;
      }
      // Don't stack on top of another open dialog (the cart drawer); wait for it to close.
      const show = () => { dialog.showModal(); document.body.classList.add('promo-popup-open'); };
      const other = document.querySelector('dialog[open]');
      if (other) other.addEventListener('close', show, { once: true });
      else show();
    })
    .catch(() => {});
})();
